import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table transaction report view.
 * @extends JetView
 */
export default class recordTableTransReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Historial de Transacciones'), // Title of the window
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying transaction details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Column header
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'),
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                    {
                        id: 'TransactionId',
                        header: _('Transacción Id'),
                        width: 150,
                        sort: 'int',
                    },
                    {
                        id: 'Amount',
                        header: _('Monto'),
                        width: 100,
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional scrolling
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto'),
                    width: 100,
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Fetching data configuration
            pager: 'pagerAA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryTransactions'; // API endpoint for fetching transactions

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails').clearAll(); // Clear previous details
            $$('dtDetails').load(url + '?id=' + idUser); // Load details for the selected user
        });

        // Event listener for item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
